import { createContext, useContext } from 'react';
import type { PostKioskTokenResolution } from './checkoutApi.js';

const PostKioskResolutionContext = createContext<PostKioskTokenResolution | null>(null);

export function usePostKioskResolution(): PostKioskTokenResolution | null {
  return useContext(PostKioskResolutionContext);
}

export { PostKioskResolutionContext };
